var _rect, _path, _path2, _path3, _path4, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 751.36 1130.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 558,
    width: 751,
    height: 572,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 558H751V1130H1V558Z",
    fill: "url(#paint0_linear_237_18)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M750.865 1130L1 1130L1 558L750.865 1130Z",
    fill: "#0078B5",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M751.302 558H0L751.302 0V558Z",
    fill: "#F25230"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V559L751.302 0H0Z",
    fill: "#FDC91F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_237_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.224 159.701C221.274 209.241 207.685 302.498 257.874 367.995L500.321 188.594C450.133 123.096 355.174 110.16 288.224 159.701Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_237_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.124 395.379C536.893 345.604 550.14 252.302 499.711 186.983L257.918 367.235C308.347 432.554 403.354 445.155 470.124 395.379Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_237_18",
    x: 223.585,
    y: 129.59,
    width: 280.736,
    height: 246.405,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_237_18"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_237_18",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_237_18",
    x: 253.918,
    y: 186.983,
    width: 280.408,
    height: 246.831,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_237_18"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_237_18",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_237_18",
    x1: 799.54,
    y1: 1087.41,
    x2: 127.514,
    y2: 423.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0235702
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0235702,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0471405,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0471405
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0707107
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0707107,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0942809,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0942809
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117851,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141421,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141421
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164992
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164992,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188562,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188562
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212132
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212132,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235702,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235702
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259272
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259272,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282843,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282843
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306413
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306413,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329983,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329983
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353553
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353553,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377124,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377124
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.400694
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.400694,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424264,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424264
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447834
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447834,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471405,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471405
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494975
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494975,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518545,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518545
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542115,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565685,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565685
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589256
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589256,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612826,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612826
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636396
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636396,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659966,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659966
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683537
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683537,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707107,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707107
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730677
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730677,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754247,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754247
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777817
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777817,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801388,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801388
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824958
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824958,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848528,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848528
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872098,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895669,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895669
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919239
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919239,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942809,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942809
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966379
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966379,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989949,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989949
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanding);
export default __webpack_public_path__ + "static/media/landing.335bfa1411ac232b3570dbd55fc4889a.svg";
export { ForwardRef as ReactComponent };